export default __webpack_public_path__ + "static/media/locationIcon.8495d8ea.svg";